import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';

// Components
import WpLabelled from 'Wpds/components/labelled/WpLabelled';
import WpAlert from 'Wpds/components/alert/WpAlert';

// Styles
import './CreditCardInput.scss';

type Props = {
  label?: string;
  hideLabel?: boolean;
  setErrorMessage: Function;
  errorMessage?: string;
};

const CreditCardInput = ({ label = 'Payment details', hideLabel = false, setErrorMessage, errorMessage }: Props) => {
  const baseClassName = 'CreditCardInput';
  return (
    <div className={baseClassName}>
      <WpLabelled id="credit-card-input" label={label} showRequiredIndicator={false} labelHidden={hideLabel}>
        <div className={`${baseClassName}__input`}>
          <CardElement
            onChange={() => setErrorMessage(null)}
            options={{
              style: {
                base: {
                  fontSize: '16px',
                  '::placeholder': {
                    color: '#9498A4',
                  },
                },
                invalid: {
                  color: '#D51C54',
                },
              },
            }}
          />
        </div>
      </WpLabelled>
      {errorMessage && (
        <div className={`${baseClassName}__error-alert`}>
          <WpAlert type="danger">{errorMessage}</WpAlert>
        </div>
      )}
    </div>
  );
};

export default CreditCardInput;
